var _styled;

// https://govuk-static.herokuapp.com/component-guide/government_navigation
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, SPACING, NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledList = styled('ul')((_styled = {
  margin: 0,
  padding: 0,
  paddingLeft: SPACING.SCALE_4,
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled), function (_ref) {
  var listStyleType = _ref.listStyleType;
  return {
    listStyleType: listStyleType || undefined,
    marginLeft: listStyleType === 'none' ? 0 : undefined,
    paddingLeft: listStyleType === 'none' ? 0 : undefined
  };
}); // TODO use Context API https://github.com/reactjs/rfcs/blob/master/text/0002-new-version-of-context.md
// listStyleType: normal HTML property values are used here
// e.g., listStyleType="circle", listStyleType="upper-alpha", listStyleType="none"

var UnorderedList = function UnorderedList(_ref2) {
  var children = _ref2.children,
      listStyleType = _ref2.listStyleType,
      className = _ref2.className;
  return React.createElement(StyledList, {
    className: className,
    listStyleType: listStyleType
  }, children);
};

UnorderedList.defaultProps = {
  listStyleType: undefined,
  className: undefined
};
UnorderedList.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  listStyleType: PropTypes.string,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(UnorderedList);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/unordered-list/es/index.js
// module id = 18
// module chunks = 0